import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class GcmUrlSerializer extends DefaultUrlSerializer {
    private excludedRegexp: RegExp;
    constructor (excludeQueryParams = /state|nonce|code|client_id|redirect.*|scope|token/i) {
        super();
        this.excludedRegexp = excludeQueryParams;
    }
    parse(url: string): UrlTree {
        const toReturn = super.parse(url); 
        //lower case all query parameters that do not match given regex
        toReturn.queryParams = 
            Object.fromEntries(
                Object.entries(toReturn.queryParams).map(([k, v]) => [!this.excludedRegexp.test(k) ? k.toLowerCase() : k, v])
            );
        return toReturn;
    }
    
}